// extracted by mini-css-extract-plugin
export default {"service":"service_service__bksO-","service__list":"service_service__list__5bn09"};